import { render, staticRenderFns } from "./EmployeeHoverCard.vue?vue&type=template&id=b10f58ca&scoped=true"
import script from "./EmployeeHoverCard.vue?vue&type=script&lang=ts"
export * from "./EmployeeHoverCard.vue?vue&type=script&lang=ts"
import style0 from "./EmployeeHoverCard.vue?vue&type=style&index=0&id=b10f58ca&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b10f58ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b10f58ca')) {
      api.createRecord('b10f58ca', component.options)
    } else {
      api.reload('b10f58ca', component.options)
    }
    module.hot.accept("./EmployeeHoverCard.vue?vue&type=template&id=b10f58ca&scoped=true", function () {
      api.rerender('b10f58ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/new/scheduler/EmployeeHoverCard.vue"
export default component.exports